/**
 * Created by Gaplo917 on 6/9/2017.
 */
import * as PIXI from 'pixi.js'
import * as Rx from 'rxjs'
import TWEEN from "@tweenjs/tween.js"
import Image from "../../objects/Image";
import R from "../../config/R";
import * as Events from "../../Events";
import {AnimationUtils} from "../../AnimationUtils";
import * as _ from "lodash";
import CustomAnimatedSprite from "../../objects/CustomAnimatedSprite";

export class Key extends PIXI.Container {
  constructor(x, y, resources){
    super()
    this.x = x
    this.y = y

    const key = new Image(0,0, resources[R.images.key.name].texture)

    this.key = key
    this.displayGroup = new PIXI.DisplayGroup(3, true)
  }

  openDoor(){
    return Rx.Observable.create((obs) => {
      this.addChild(this.key)
      this.rotation = -2.5

      this._tween = new TWEEN.Tween(this)
        .to({x: 1950}, 2000)
        .easing(TWEEN.Easing.Quadratic.InOut)
        .onComplete(() => {
        })
        .start()

      this._tween = new TWEEN.Tween(this)
        .to({y: 1020}, 2000)
        .easing(TWEEN.Easing.Quadratic.InOut)
        .onComplete(() => {
          obs.next()
          obs.complete()
        })
        .start()
    })
  }

  normal(){
  }

}



// WEBPACK FOOTER //
// ./src/game/characters/level2/Key.js